import {performHttpRequest} from "../http";

export async function getDomainListItems(formID, data) {

    const wizard = window.wizard

    return performHttpRequest(
        window.kaartViewerUrl + `/admin/rest/openapi/${window.websiteName}/${window.categoryName}/filter/${formID}?request=unique&trekking=1&ts=${Date.now()}`,
        // window.kaartViewerUrl + `/admin/rest/kaartviewerapi/bookmark/${wizard.settings.BookmarkID}/domain/${wizard.settings.DomainID}/presentation/${wizard.Presentation.ID}/filter/${formID}?request=unique&trekking=1&ts=${Date.now()}`,
        'POST',
        data
    )
}
